import React from "react"

import styles from "./ContentBox.module.scss"

const ContentBox = ({ html = "", emphasis = true }) => {
  const htmlFormatted = html.replaceAll("<p><a ", "<p><a data-first-link ")
  return (
    <div
      className={`${styles.element} ${
        emphasis ? `${styles.emphasis} make-full-width-on-mobile` : ""
      }`}
      dangerouslySetInnerHTML={{
        __html: htmlFormatted,
      }}
    ></div>
  )
}

export default ContentBox
